import axiosInstance from '@/utils/axiosInstance';
import { showAlert } from '@/components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

export const getBiCustomers = async (
  page,
  size,
  search,
  sortField,
  sortDirection,
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/sales-customers?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortField}&sortDir=${sortDirection}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const createBiCustomer = async (customerData) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/sales-customers',
      customerData,
    );
    showAlert('success', 'Customer created successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const updateBiCustomer = async (customerId, customerData) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/sales-customers/${customerId}`,
      customerData,
    );
    showAlert('success', 'Customer updated successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const deleteBiCustomer = async (customerId) => {
  try {
    await axiosInstance.delete(
      `/SmartProAPI/api/sales-customers/${customerId}`,
    );
    showAlert('success', 'Customer deleted successfully');
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const uploadBiCustomersFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axiosInstance.post(
      '/SmartProAPI/api/sales-customers/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const confirmBiCustomers = async (data) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/sales-customers/confirm-updates',
      data,
    );
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const getSalesReps = async () => {
  try {
    const res = await axiosInstance.get('/SmartProAPI/api/sales-rep');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const sendBiCustommerMonthlyReport = async () => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/sales-customers/send-bi-customer-monthly-report',
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
